export const BENEFIT_ROLE = "BENEFITI_USER_ROLE";
export const BENEFIT_TOKEN = "BENEFIT_TOKEN";
export const BENEFIT_REFRESH_TOKEN = "BENEFIT_REFRESH_TOKEN";
